import React from "react";
import Footer from "../components/Footer";
import Navbars from "../components/Navbars";

const LayoutPublik = (props) => {
  return (
    <React.Fragment>
      <div className="container mx-auto">
        <Navbars />
        {props.children}
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default LayoutPublik;
